import React, { memo } from 'react';
import {
  string, func,
} from 'prop-types';
import Locale from '@active/react-utils/i18n/Locale';
import { withI18n } from '@active/react-utils/i18n/LocaleContext';
import Alert from '@active/react-ui/Alert';
import paymentMethodsMap from '../../../../../shared/config/paymentMethodsMap';

const PaymentInfoTag = ({
  paymentMethodType,
  i18n,
}) => {
  if (paymentMethodType && (paymentMethodType === 'CREDIT_CARD' || paymentMethodType === 'ECHECK')) {
    const values = { 0: i18n(paymentMethodsMap[paymentMethodType]) };
    return (
      <div className="payment-info-tag" data-testid="payment-Info-alert">
        <Alert theme="inline">
          <span className="payment-method">
            <Locale id='checkout.lib.components.text.futureBilling' params={values} />
          </span>
        </Alert>
      </div>);
  }
  return null;
};

PaymentInfoTag.propTypes = {
  paymentMethodType: string,
  i18n: func.isRequired,
};

export default withI18n(memo(PaymentInfoTag));
